import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-personnes-professionnels',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-personnes-professionnels.component.html',
  styleUrls: ['./assurance-personnes-professionnels.component.scss']
})
export class AssurancePersonnesProfessionnelsComponent {
  title = 'Assurance des Personnes pour Professionnels et Entreprises';
  subtitle = '';
  heroImage = 'assets/static_pages_images/Syndics_de_la_guilde_des_drapiers.jpg';

  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'Assurance des Personnes', link: undefined }
  ];

  prevPage = { title: 'Assurance des Personnes pour Particuliers',
    link: '/assurance-sante-particuliers'
  };

  nextPage = { title: 'Assurance des Biens pour Particuliers',
    link: '/assurance-biens-particuliers'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }

  navigateToPrevoyancePro(): void {
    this.router.navigate(['/assurance-prevoyance-professionnelle']);
  }
}
